import {
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import {
  uigAccessSubjectFeatureKey,
  UigAccessSubjectState,
  UIG_ACCESS_SUBJECT_OVERVIEW
} from './uig-access-subject.reducer';

export const selectUigAccessSubjectState = createFeatureSelector<UigAccessSubjectState>(
  uigAccessSubjectFeatureKey
);

//******************************************************

export const selectUigAccessSubjectOverview = createSelector(
    selectUigAccessSubjectState,
    (state: UigAccessSubjectState) =>
        state[UIG_ACCESS_SUBJECT_OVERVIEW].uigAccessSubjectOverview
);

export const loadingUigAccessSubjectOverview = createSelector(
    selectUigAccessSubjectState,
    (state: UigAccessSubjectState) =>
        state[UIG_ACCESS_SUBJECT_OVERVIEW].isLoading
);

export const errorUigBranchesOverview = createSelector(
  selectUigAccessSubjectState,
    (state: UigAccessSubjectState) =>
        state[UIG_ACCESS_SUBJECT_OVERVIEW].error
);
